"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hash_1 = require("./hash");
const ERR_INVALID_TREE = "Invalid tree";
const ERR_NOT_IMPLEMENTED = "Not implemented";
class Node {
    get root() {
        throw new Error(ERR_NOT_IMPLEMENTED);
    }
    isLeaf() {
        throw new Error(ERR_NOT_IMPLEMENTED);
    }
    get left() {
        throw new Error(ERR_NOT_IMPLEMENTED);
    }
    get right() {
        throw new Error(ERR_NOT_IMPLEMENTED);
    }
    rebindLeft(left) {
        throw new Error(ERR_NOT_IMPLEMENTED);
    }
    rebindRight(right) {
        throw new Error(ERR_NOT_IMPLEMENTED);
    }
}
exports.Node = Node;
class BranchNode extends Node {
    constructor(_left, _right) {
        super();
        this._left = _left;
        this._right = _right;
        this._root = null;
        if (!_left || !_right)
            throw new Error(ERR_INVALID_TREE);
    }
    get root() {
        if (!this._root) {
            this._root = hash_1.hash(this.left.root, this.right.root);
        }
        return this._root;
    }
    isLeaf() {
        return false;
    }
    get left() {
        return this._left;
    }
    set left(n) {
        this._left = n;
    }
    get right() {
        return this._right;
    }
    set right(n) {
        this._right = n;
    }
    rebindLeft(left) {
        return new BranchNode(left, this.right);
    }
    rebindRight(right) {
        return new BranchNode(this.left, right);
    }
}
exports.BranchNode = BranchNode;
class LeafNode extends Node {
    constructor(_root) {
        super();
        this._root = _root;
        if (_root.length !== 32)
            throw new Error(ERR_INVALID_TREE);
    }
    get root() {
        return this._root;
    }
    isLeaf() {
        return true;
    }
}
exports.LeafNode = LeafNode;
function identity(n) {
    return n;
}
exports.identity = identity;
function compose(inner, outer) {
    return function (n) {
        return outer(inner(n));
    };
}
exports.compose = compose;
